// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAutoInvestmentRuleDto
 */
export interface IAutoInvestmentRuleDto {
    /**
     * 
     * @type {number}
     * @memberof IAutoInvestmentRuleDto
     */
    instrument_id: number;
    /**
     * 
     * @type {number}
     * @memberof IAutoInvestmentRuleDto
     */
    percentage: number;
}

/**
 * Check if a given object implements the IAutoInvestmentRuleDto interface.
 */
export function instanceOfIAutoInvestmentRuleDto(value: object): value is IAutoInvestmentRuleDto {
    if (!('instrument_id' in value) || value['instrument_id'] === undefined) return false;
    if (!('percentage' in value) || value['percentage'] === undefined) return false;
    return true;
}

export function IAutoInvestmentRuleDtoFromJSON(json: any): IAutoInvestmentRuleDto {
    return IAutoInvestmentRuleDtoFromJSONTyped(json, false);
}

export function IAutoInvestmentRuleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAutoInvestmentRuleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'instrument_id': json['instrument_id'],
        'percentage': json['percentage'],
    };
}

export function IAutoInvestmentRuleDtoToJSON(json: any): IAutoInvestmentRuleDto {
    return IAutoInvestmentRuleDtoToJSONTyped(json, false);
}

export function IAutoInvestmentRuleDtoToJSONTyped(value?: IAutoInvestmentRuleDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instrument_id': value['instrument_id'],
        'percentage': value['percentage'],
    };
}

